import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { AlertController, ModalController, NavController, ViewWillEnter } from "@ionic/angular";
import { Observable, Subscription, firstValueFrom, map, of, switchMap } from "rxjs";
import { NavbarService } from "src/app/core/services/behavior/navbar.service";
import { AuthenticationService } from "src/app/core/services/http/authentication.service";
import { PedidoService } from "src/app/core/services/http/pedido.service";
import { ModalRoleEnum } from "src/app/shared/enums/modal-role.enum";
import { TipoAtendimentoEnum } from "src/app/shared/enums/tipo-atendimento.enum";
import { ModalResult } from "src/app/shared/interfaces/modal-result.interface";
import { MesasOcupadasModel } from "src/app/shared/models/mesas-ocupadas.model";
import { PedidoModel, TransferenciaMesaRequest } from "src/app/shared/models/pedido.model";
import { DialogStateUtil } from "../../utils/dialog-state.util";
import { CadastroProdutosDialogComponent } from "../cadastro-produtos-dialog/cadastro-produtos-dialog.component";
import { PagarContaComponent } from "../pagar-conta/pagar-conta.component";
import { SelecionarProdutoComponent, SelecionarProdutoDataClose } from "../selecionar-produto/selecionar-produto.component";
import { TransferenciaMesaComponent, TransferenciaMesaDataClose } from "../transferencia-mesa/transferencia-mesa.component";
import { FechamentoCaixaDialogComponent } from "../fechamento-caixa-dialog/fechamento-caixa-dialog.component";
import { CaixaService } from "src/app/core/services/http/caixa.service";
import { CaixaResponse } from "../../models/caixa-response";
import { ManutencaoMesasDialogComponent } from "../manutencao-mesas-dialog/manutencao-mesas-dialog.component";
import { OperacaoPgtoEnum } from "../../enums/operacao-pgto.enum";
import { SangriaSuprimentoDialogComponent } from "../sangria-suprimento-dialog/sangria-suprimento-dialog.component";
import { LocalizarPedidoInputService } from "src/app/core/services/behavior/localizar-pedido-input.service";
import { StorageService } from "src/app/core/services/behavior/storage.service";
import { environment } from "src/environments/environment";
import { UsuarioModel } from "../../models/usuario.model";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { ConfiguracaoPedidoDialogComponent } from "../configuracao-pedido-dialog/configuracao-pedido-dialog.component";
import { ConfigPdvDeliveryRequest, ConfigPdvDeliveryResponse } from "../../models/configuracao.model";
import { ProdutosIntegracaoResponse } from "../../models/produto.model";
import { FormaPgtoRequestV1 } from "../../models/forma-pgto.model";
import { CastModelUtils } from "../../utils/CastModelUtils";
import { SistemaService } from "src/app/core/services/http/sistema.service";
import { DeviceService } from "src/app/core/services/behavior/device.service";
import { ConfigSistemaService } from "src/app/core/services/behavior/config-sistema.service";
import { DatetimeService } from "src/app/core/services/http/datetime.service";
import { ProdutoService } from "src/app/core/services/http/produto.service";
import { TamanhoService } from "src/app/core/services/http/tamanho.service";

export type ActiveTabCustomType = "mesas" | "delivery" | "balcao";

@Component({
    selector: "app-navbar",
    templateUrl: "./navbar.component.html",
    styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit, OnDestroy, ViewWillEnter {
    @ViewChild("numeroComandaInpt", { static: false })
    private numeroComandaInpt: ElementRef<HTMLInputElement>;
    @ViewChild("senhaInput", { static: false })
    private senhaInput: ElementRef<HTMLInputElement>;

    txtSenha: string = "";
    private subs$: Subscription[] = [];

    @Input() public activeTab: ActiveTabCustomType;
    @Output() public mudarActiveTab = new EventEmitter<MudarActiveTabData>();
    @Output() public reload = new EventEmitter();

    public caixaAberto: CaixaResponse | null = null;
    public numeroComanda: number = null;
    public usuarioLogado = this.authService.user;
    public focoAutomatico: boolean = true;
    public numeroCaixa: number = 0;
    public produtoIntegracao: ProdutosIntegracaoResponse = null;

    constructor(
        private alertCtrl: AlertController,
        private modalCtrl: ModalController,
        private storageService: StorageService,
        private sistemaService: SistemaService,

        private _localizarPedidoInputService: LocalizarPedidoInputService,
        private authService: AuthenticationService,
        private _caixaService: CaixaService,
        private pedidoService: PedidoService,
        private _navbarService: NavbarService,
        private _navCtrl: NavController,
        private router: Router,
        private dialog: MatDialog,
        private deviceService: DeviceService,
        private configSistemaService: ConfigSistemaService,
        private datetimeService: DatetimeService,
        private produtoService: ProdutoService,
        private tamanhoService: TamanhoService,
    ) {
        this.numeroCaixa = this.authService.numeroCaixa;
    }

    ngOnDestroy(): void {
        this.subs$.forEach((sub$) => sub$.unsubscribe());
    }

    ngOnInit(): void {
        this.carregarConfigPedido();

        //tem que resetar o usuário logado após o enviarpedido
        const sub$ = this._navbarService.focarNumeroMesaInput$.subscribe((res) => {
            if (res) {
                if (!this.focoAutomatico) {
                    return;
                }

                if ((this.usuarioLogado.codigo == 0) && this.exibirTxtSenha) {
                    this.senhaInput.nativeElement.focus();
                } else {
                    this.numeroComandaInpt.nativeElement.focus();
                }

                this._navbarService.focarNumeroMesaInput$.next(false);
            }
        });

        this._obterCaixa();

        this._caixaService.caixaAberto$.subscribe((res) => {
            if (res) this._obterCaixa();
        });
    }

    ionViewWillEnter(): void { }

    public get getDesabilitarInpsDeAcao() {
        const naoContemValor = !this.numeroComanda;
        const valorNaoNumerico = /[^0-9]/g.test(
            (this.numeroComanda ?? "").toString()
        );

        return naoContemValor || valorNaoNumerico;
    }

    public get getPlaceholder() {
        switch (this.activeTab) {
            case "balcao":
                return "Balcão";
            case "delivery":
                return "Delivery";
            case "mesas":
                return "Mesa";
        }
    }

    public async abrirCadastroProdutosDialogOnClick() {
        const modal = await this.modalCtrl.create({
            component: CadastroProdutosDialogComponent,
            cssClass: "full-screen-dialog",
        });

        await modal.present();

        DialogStateUtil.dialogIsOpen();
    }

    public async abrirProdutoIntegracao() {
        this._navCtrl.navigateRoot('/integracao');
    }

    public async abrirModalFechamentoCaixaAsyncOnClick() {
        const modal = await this.modalCtrl.create({
            component: FechamentoCaixaDialogComponent,
            cssClass: "fechamento-caixa-dialog",
        });

        await modal.present();

        DialogStateUtil.dialogIsOpen();
    }

    public async abrirModalManutencaoMesasAsyncOnClick() {
        const modal = await this.modalCtrl.create({
            component: ManutencaoMesasDialogComponent,
            cssClass: "manutencao-mesas-dialog",
        });

        await modal.present();

        DialogStateUtil.dialogIsOpen();

        const { data, role } = await modal.onDidDismiss();

        DialogStateUtil.dialogIsClosed();
    }

    public async abrirModalSangriaAsyncOnClick() {
        const modal = await this._obterModalSangriaSuprimentoAsync(
            OperacaoPgtoEnum.Sangria
        );

        await modal.present();

        DialogStateUtil.dialogIsOpen();

        await modal.onWillDismiss();

        DialogStateUtil.dialogIsClosed();
    }

    public async abrirModalSuprimentoAsyncOnClick() {
        const modal = await this._obterModalSangriaSuprimentoAsync(
            OperacaoPgtoEnum.Suprimento
        );

        await modal.present();

        DialogStateUtil.dialogIsOpen();

        await modal.onWillDismiss();

        DialogStateUtil.dialogIsClosed();
    }

    public abrirTaxaEntrega() {
        this.router.navigate(['taxa-entrega']);
    }

    public abrirPizza() {
        this.router.navigate(['integracao-pizza-lasanha', 'pizza']);
    }

    public abrirLasanha() {
        this.router.navigate(['integracao-pizza-lasanha', 'lasanha']);
    }

    public abrirSorvete() {

    }

    public abrirMacarrao() {

    }

    public carregarConfigPedido() {
        this.pedidoService.getConfigPedido().subscribe({
            next: async (res) => {
                if (res.success) {
                    const config = res.data as ConfigPdvDeliveryResponse;
                    await this.configSistemaService.alterarConfig(config);
                }
            }
        });
    }

    public alterarConfigPedido(configPedido: ConfigPdvDeliveryResponse) {    
        let request = CastModelUtils.ClonarObjetoComPropriedadesIguais(configPedido, new ConfigPdvDeliveryRequest());

        this.sistemaService.setConfigDelivery(request).subscribe(async (res) => {
            if (!res.success) {
                return;
            }

            await this.configSistemaService.alterarConfig(configPedido);
        });
    }

    public abrirConfiguracaoImpressao() {
        this.router.navigate(['configuracao-impressao']);
    }

    public abrirConfiguracaoPedido() {
        this.focoAutomatico = false;

        const dialogRef = this.dialog.open(ConfiguracaoPedidoDialogComponent, {
            data: this.configSistemaService.config,
        });

        dialogRef.afterClosed().subscribe((res) => {
            this.alterarConfigPedido(res);
            this.focoAutomatico = true;
        });
    }

    public abrirCadastroPerguntas() {
        this.router.navigate(['perguntas']);
    }

    public imprimir(): void {
        const obs$ = this.verificarMesaOcupada(this.numeroComanda).pipe(
            switchMap((mesaOcupada) =>
                mesaOcupada
                    ? this.pedidoService.imprimirPedido(this.numeroComanda)
                    : of(null)
            )
        );

        const sub$ = obs$.subscribe(async (res) => {
            if (!res) {
                await this.showAlert("Mesa está fechada.");
            }

            this._limparInput();

            this.reload.emit(true);
        });

        this.subs$.push(sub$);
    }

    public async modalPagarConta(): Promise<void> {
        if (!this.numeroComanda) return;

        const sub$ = this.verificarMesaOcupada(this.numeroComanda).subscribe(
            async (res) => {
                if (!res) {
                    await this.showAlert("Mesa está fechada.");
                } else {
                    const pedido: PedidoModel = new PedidoModel({
                        numeroComanda: this.numeroComanda,
                    });

                    const modal = await this.modalCtrl.create({
                        component: PagarContaComponent,
                        componentProps: {
                            pedido: pedido,
                            //tipoAtendimento: TipoAtendimentoEnum.MESA
                        },
                        cssClass: "full-screen-dialog",
                    });

                    await modal.present();

                    DialogStateUtil.dialogIsOpen();

                    const modalResult: ModalResult = await modal.onWillDismiss();

                    DialogStateUtil.dialogIsClosed();

                    this._limparInput();

                    if (modalResult.role === ModalRoleEnum.CONFIRM) {
                        this.reload.emit(true);
                    }
                }
            }
        );

        this.subs$.push(sub$);
    }

    public modalSelecionarProdutos(event): void {
        event.preventDefault();
        event.stopPropagation();

        if (!this.numeroComanda) return;

        const mesaCadastradaSub = this.verificarMesaCadastrada(
            this.numeroComanda
        ).subscribe(async (mesaCadastrada) => {
            if (!mesaCadastrada) {
                await this.showAlert("Mesa não está cadastrada.");
                return;
            }

            const obterMesaSub = this.pedidoService
                .obterMesa(this.numeroComanda)
                .subscribe((res) => {
                    if (!res.success) return;

                    const tipoMesa = res.data.grupo;

                    if (tipoMesa === TipoAtendimentoEnum.MESA) {
                        this._prosseguirComPedido(tipoMesa);
                        const activeTab =
                            this._converterTipoAtendimentoEnumParaActiveTab(tipoMesa);
                        this.mudarActiveTab.emit({
                            activeTab: activeTab,
                            numeroComanda: this.numeroComanda,
                        });
                        return;
                    } else {
                        this._navbarService.numeroComandaDigitado$.next(this.numeroComanda);
                    }

                    const mesaOcupadaSub = this.verificarMesaOcupada(
                        this.numeroComanda
                    ).subscribe(async (mesaOcupada) => {
                        if (!mesaOcupada) {
                            await this.showAlert("Pedido inexistente.");
                        } else {
                            const activeTab =
                                this._converterTipoAtendimentoEnumParaActiveTab(tipoMesa);
                            this.mudarActiveTab.emit({
                                activeTab: activeTab,
                                numeroComanda: this.numeroComanda,
                            });
                        }
                    });

                    this.subs$.push(mesaOcupadaSub);
                });

            this.subs$.push(obterMesaSub);
        });

        this.subs$.push(mesaCadastradaSub);
    }

    public async modalTransferenciaMesa(): Promise<void> {
        const sub$ = this.verificarMesaOcupada(this.numeroComanda).subscribe(
            async (res) => {
                if (!res) {
                    await this.showAlert("Mesa está fechada.");
                } else {
                    const mesa = new MesasOcupadasModel();

                    mesa.numeroComanda = this.numeroComanda;

                    const modal = await this.modalCtrl.create({
                        component: TransferenciaMesaComponent,
                        componentProps: {
                            mesa: mesa,
                        },
                        cssClass: "full-screen-dialog",
                    });

                    await modal.present();

                    DialogStateUtil.dialogIsOpen();

                    const modalResult: ModalResult<TransferenciaMesaDataClose> =
                        await modal.onWillDismiss();

                    DialogStateUtil.dialogIsClosed();

                    this._limparInput();

                    if (modalResult.role === ModalRoleEnum.CONFIRM) {
                        const request = {
                            numeroComanda: mesa.numeroComanda,
                            numeroComandaDestino: modalResult.data.numeroComandaDestino,
                            codigosVendasDet: modalResult.data.codigosDet,
                        } as TransferenciaMesaRequest;

                        const sub$ = this.pedidoService
                            .transferenciaMesa(request)
                            .subscribe(() => this.reload.emit(true));

                        this.subs$.push(sub$);
                    }
                }
            }
        );

        this.subs$.push(sub$);
    }

    public CampoSenhaTemFoco = (valor: boolean) =>
        (this._localizarPedidoInputService.campoSenhaComFoco = valor);

    public async sincronizarDados() {
        await this.storageService.remove(environment.milisegundosAtualizacaoTelaDeliveryKey);
        await this.storageService.remove('configPedido');

        await this.loadAll();

        window.location.href = window.location.pathname + '?t=' + Date.now();
    }

    private async loadAll(): Promise<void> {
        await Promise.all([
            this.loadAndStore(() => this.produtoService.getProdutosDelivery(), 'produtos'),
            this.loadAndStore(() => this.produtoService.getProdutosFamilia(), 'familiaProdutos'),
            this.loadAndStore(() => this.tamanhoService.getTamanhosLasanha(), 'tamanhosLasanha'),
            this.loadAndStore(() => this.tamanhoService.getTamanhosPizza(), 'tamanhosPizza'),
            this.loadAndStore(() => this.sistemaService.getConfiguracoes(), 'configuracoes', null)
        ]);
    }

    private async loadAndStore(request: () => Observable<any>, key: string, fallback: any = []): Promise<void> {
        const res = await firstValueFrom(request());
        const data = res.success ? res.data : fallback;

        await this.storageService.set(key, data);
    }

    public async onLogout(): Promise<void> {
        await this.authService.logout({
            removeDatabaseName: false,
            removeBaseUrl: false,
        });
    }

    @HostListener("window:keydown", ["$event"])
    public async onKeydown(event: KeyboardEvent): Promise<void> {
        switch (event.key) {
            case "F8":
                if (this.activeTab === "mesas") {
                    this.numeroComandaInpt.nativeElement.focus();
                }

                break;

            case "F5":
                event.preventDefault();
                event.stopPropagation();

                const existeModalAberto = await this.modalCtrl.getTop();

                if (!DialogStateUtil.isDialogCurrentlyOpen && !existeModalAberto) {
                    await this.modalPagarConta();
                }

                break;
            case "F2":
                event.preventDefault();
                event.stopPropagation();

                if (this.activeTab === 'mesas') {
                    this.numeroComandaInpt.nativeElement.focus();
                }
        }
    }

    exibirTxtSenha: boolean = false;

    public async loadSolicitarSenha() {
        var solicitarSenhaSomentePrimeiraVez =
            (await this.storageService.get("solicitarSenhaSomentePrimeiraVez")) ??
            true;
        this.exibirTxtSenha = !solicitarSenhaSomentePrimeiraVez;

        if (this.exibirTxtSenha) {
            setTimeout(() => {
                this.senhaInput.nativeElement.focus();
            }, 1500);
        }
    }

    public async autenticarUsuarioComSenha() {
        this.authService.loginSomenteComSenha(this.txtSenha).subscribe({
            next: async (res) => {
                if (res.success) {
                    var usuario = res.data as UsuarioModel;
                    await this.storageService.set(
                        environment.credentialsKeys.user,
                        usuario
                    );
                    this.usuarioLogado = usuario;

                    this._navbarService.focarNumeroMesaInput$.next(true);
                }
                this.txtSenha = "";
            },
        });
    }

    private _converterTipoAtendimentoEnumParaActiveTab(
        tipoAtendimento: TipoAtendimentoEnum
    ) {
        let activeTab: ActiveTabCustomType;

        switch (tipoAtendimento) {
            case TipoAtendimentoEnum.BALCAO:
                activeTab = "balcao";
                break;
            case TipoAtendimentoEnum.DELIVERY:
                activeTab = "delivery";
                break;
            case TipoAtendimentoEnum.MESA:
                activeTab = "mesas";
                break;
        }

        return activeTab;
    }

    private _limparInput() {
        this.numeroComandaInpt.nativeElement.value = "";
    }

    private _obterCaixa() {
        const sub$ = this._caixaService
            .obterCaixaPorCodigoUsuario(this.usuarioLogado.codigo, this.numeroCaixa)
            .pipe(map((l) => (l.success ? l.data : null)))
            .subscribe(async (res) => {                
                this.caixaAberto = res;
                await this.loadSolicitarSenha();
            });

        this.subs$.push(sub$);
    }

    private async _obterModalSangriaSuprimentoAsync(tipoCaixa: OperacaoPgtoEnum) {
        return await this.modalCtrl.create({
            component: SangriaSuprimentoDialogComponent,
            cssClass: "sangria-suprimento-dialog",
            componentProps: {
                operacaoCaixa: tipoCaixa,
            },
        });
    }

    private async _prosseguirComPedido(tipoAtendimento: TipoAtendimentoEnum) {
        const pedido = new PedidoModel({ numeroComanda: this.numeroComanda });

        const modal = await this.modalCtrl.create({
            component: SelecionarProdutoComponent,
            componentProps: {
                pedido: pedido,
                tipoAtendimento: tipoAtendimento,
            },
            cssClass: "full-screen-dialog",
            backdropDismiss: false,
            keyboardClose: false,
        });

        await modal.present();

        DialogStateUtil.dialogIsOpen();

        const modalResult: ModalResult<SelecionarProdutoDataClose> =
            await modal.onWillDismiss();

        DialogStateUtil.dialogIsClosed();

        this._limparInput();

        if (modalResult.role === ModalRoleEnum.CONFIRM) {
            const formaPgto = new FormaPgtoRequestV1();
            modalResult.data.pedido.FormaPgtoOldV1 = formaPgto;
            modalResult.data.pedido.terminalId = this.deviceService.device.idDispositivo;

            const datahora = await this.datetimeService.obterDataHora();
            modalResult.data.pedido.dataHora = datahora;

            const sub$ = this.pedidoService
                .enviarPedido(modalResult.data.pedido, TipoAtendimentoEnum.MESA)
                .subscribe((res) => {
                    if (res.success) {
                        if (this.exibirTxtSenha) {
                            this.usuarioLogado = new UsuarioModel();
                            this.authService.user = this.usuarioLogado;

                            this._navbarService.focarNumeroMesaInput$.next(true);
                        }

                        this.reload.emit();
                    }
                });

            this.subs$.push(sub$);
        }
    }

    private async showAlert(msg: string) {
        const alert = await this.alertCtrl.create({
            header: "ATENÇÃO",
            message: msg,
            buttons: ["OK"],
        });

        await alert.present();
    }

    private verificarMesaCadastrada(numeroComanda: number) {
        return this.pedidoService
            .verificarMesaCadastrada(numeroComanda)
            .pipe(map((l) => (l.success ? l.data : false)));
    }

    private verificarMesaOcupada(numeroComanda: number) {
        return this.pedidoService
            .verificarMesaOcupada(numeroComanda)
            .pipe(map((l) => (l.success ? l.data : false)));
    }
}

export class MudarActiveTabData {
    public activeTab: ActiveTabCustomType;
    public numeroComanda: number;
}
